import React, { useMemo } from "react";
import { Typography } from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";

const extractDomain = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};

const LinkPreviewCard = ({ preview }) => {
  if (!preview?.url) return null;

  const domain = useMemo(() => extractDomain(preview.url), [preview.url]);

  // thumbnail → base64 from extendedTextMessage; image → URL from og: fetch
  const imgSrc = preview.thumbnail
    ? `data:image/jpeg;base64,${preview.thumbnail}`
    : preview.image || null;

  const handleOpen = () => {
    window.open(preview.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      onClick={handleOpen}
      style={{
        cursor: "pointer",
        marginTop: "6px",
        borderRadius: "8px",
        overflow: "hidden",
        border: "1px solid rgba(0,0,0,0.12)",
        maxWidth: "320px",
        background: "inherit",
      }}
    >
      {imgSrc && (
        <img
          src={imgSrc}
          alt={preview.title || domain}
          style={{ width: "100%", maxHeight: "160px", objectFit: "cover", display: "block" }}
        />
      )}
      <div style={{ padding: "8px 10px 6px" }}>
        {preview.title && (
          <Typography
            variant="body2"
            style={{ fontWeight: 600, lineHeight: 1.3, marginBottom: "2px" }}
            noWrap
          >
            {preview.title}
          </Typography>
        )}
        {preview.description && (
          <Typography
            variant="caption"
            color="textSecondary"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              lineHeight: 1.4,
            }}
          >
            {preview.description}
          </Typography>
        )}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
            marginTop: "4px",
          }}
        >
          <LinkIcon style={{ fontSize: "12px", opacity: 0.5 }} />
          <Typography
            variant="caption"
            color="textSecondary"
            style={{ fontSize: "11px", opacity: 0.7 }}
            noWrap
          >
            {domain}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default LinkPreviewCard;
